module.exports = __webpack_public_path__ + "media/entities/2013-109397a9.png";